/**
 * Represents an endorsement submitted for a promotion packet.
 */
export interface Endorsement {
  id: string;
  packetId: string; // Link back to the packet
  endorserId: string; // User ID of the endorser
  content: string;
  createdAt: Date;
  updatedAt: Date;
}

/**
 * Data transfer object for creating a new endorsement
 */
export interface CreateEndorsementDTO {
  packetId: string;
  content: string;
  /** Optional override: managers may supply a user ID to create on behalf of that endorser */
  endorserId?: string;
}

/**
 * Data transfer object for updating an existing endorsement
 */
export interface UpdateEndorsementDTO {
  content: string;
}

/**
 * Validation rules for endorsements/invitations
 */
export const ENDORSEMENT_VALIDATION = {
  MAX_ENDORSERS: 10,
  MAX_CONTENT_LENGTH: 5000,
} as const;

// We might also need related DTOs later, similar to criteria
// export interface CreateEndorsementDTO { ... }
// export interface UpdateEndorsementDTO { ... }
